import React, { Component } from "react";
import "../App.css";
import { getText } from "../Text";
import Container from 'react-bootstrap/Container'
import projectImage from "../static/img/inspectionFlow.png"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stepper from "../Components/MyStepper"
import {Checkmark} from 'react-checkmark';


class Inspection extends Component {
	render() {
		const language = this.props.language
		return (
			<div className>
				<div className="inspectionFlow" style={{backgroundImage: `url(${projectImage})`}}>
					<Container>
						<div className="pastProject-header">
							<h1 className="bannerHeader"> {getText(language).inspection_page.header} </h1>
						</div>
					</Container>
				</div>
				<Container>
                    <Row>
                        <Col className="contactHeader">
                            <h2 >
								{getText(language).inspection_page.header_2}
                            </h2>
							<Stepper steps={getText(language).inspection_page.process_flow_diagram}/>
                        </Col>
                    </Row>
					<hr/>
					<Row>
						<Col className="contactHeader">
							<h2 className="exitHeader">
							{getText(language).inspection_page.subheader_2.header}
							</h2>
							<div className="exitEntry">
								<Checkmark className="checkmark"/> {getText(language).inspection_page.subheader_2.bullet_1}
							</div>
							<div className="exitEntry">
								<Checkmark className="checkmark"/> {getText(language).inspection_page.subheader_2.bullet_2}
							</div>
							<div className="exitEntry">
								<Checkmark className="checkmark"/> {getText(language).inspection_page.subheader_2.bullet_3}
							</div>
							<div className="exitEntry">
								<Checkmark className="checkmark"/> {getText(language).inspection_page.subheader_2.bullet_4}
							</div>
							<div className="exitEntry">
								<Checkmark className="checkmark"/> {getText(language).inspection_page.subheader_2.bullet_5}
							</div>
						</Col>
					</Row>
                </Container>
			</div>
		);
	}
}

export default Inspection;
